/**
 * Baixa o anexo de uma resposta rápida e o devolve como File, pronto para
 * entrar no pipeline normal de upload do compositor.
 *
 * Usa `fetch_url` (rota proxy do ActiveStorage, sempre same-origin) e não
 * `file_url` (rota :redirect, que manda o browser pro bucket e quebraria por
 * CORS em S3/GCS). Sem `credentials`: a rota autentica pelo signed_id no path,
 * então mandar cookie só serviria pra disparar preflight.
 *
 * NOTA: reanexamos como arquivo novo de propósito, em vez de reaproveitar o
 * blob original via signed_id — apagar a mensagem purgaria o arquivo da
 * resposta rápida e a quebraria para a conta inteira.
 *
 * @param {Object} attachment - item de canned_response.attachments
 * @returns {Promise<File>}
 */
export async function cannedAttachmentToFile(attachment) {
  const response = await fetch(attachment.fetch_url || attachment.file_url);
  if (!response.ok) throw new Error(response.statusText);

  const blob = await response.blob();
  return new File([blob], attachment.filename, {
    type: attachment.content_type || blob.type,
  });
}

export default { cannedAttachmentToFile };
